import axios from 'axios';
import { getToken } from '@starberry/myaccount-website-utils'

const baseURL = `${process.env.GATSBY_STRAPI_FORM_URL}`;
const token = getToken() || process.env.GATSBY_STRAPI_FORM_TOKEN;

const authInstance = axios.create({
  baseURL: baseURL,
  headers: {
    Authorization: `Bearer ${token}`,
    // "Content-Type": "multipart/form-data"
  },
});


export const postFileData = async (data) => {

  const res = await authInstance.post('upload', data)
  .then((res) => {
    // Success
    if (res.statusText === 'OK') {
      return {
        success: true,
        ...res.data,
      }
    }
    return { success: false }
  })
  .catch((error) => {
    // Failed
    if (error.response) {
      return {
        success: false,
        message: error.response.data,
      }
    } else {
      // Service error
    }
  })

  return res;

}

export const postFormData = async (data) => {

  const res = await authInstance.post('forms', data)
  .then((res) => {
    // Success
    if (res.statusText === 'OK') {
      return {
        success: true,
        ...res.data,
      }
    }
    return { success: false }
  })
  .catch((error) => {
    // Failed
    if (error.response) {
      return {
        success: false,
        message: error.response.data,
      }
    } else {
      // Service error
    }
  })

  return res;

}

export function nameValidation(name) {
  const ERROR = {
    name: "Invalid name",
  };

  //Check if name is a string
  if (typeof name !== "string") {
    return { valid: false, message: ERROR.name };
  }

  name = name.trim();

  //Minimum length
  if (name.length < 2) {
    return { valid: false, message: "Name must be at least 2 characters" };
  }

  //Maximum length
  if (name.length > 60) {
    return { valid: false, message: "Name is too long" };
  }

  // Regex: only letters, spaces, apostrophes, dots, and hyphens
  const namePattern = /^[A-Za-z\s'.-]+$/;
  if (!namePattern.test(name)) {
    return { valid: false, message: "Enter a valid name" };
  }

  // Check for at least one vowel
  if (!/[aeiou]/i.test(name)) {
    return { valid: false, message: "Enter a valid name" };
  }

  // Check for not too many consecutive consonants
  if (/[bcdfghjklmnpqrstvwxyz]{4,}/i.test(name)) {
    return { valid: false, message: "Enter a valid name" };
  }

  // Check for not too many consecutive vowels
  if (/[aeiou]{4,}/i.test(name)) {
    return { valid: false, message: "Enter a valid name" };
  }

  // Check for too many repeated characters
  if (/(.)\1{3,}/i.test(name)) {
    return { valid: false, message: "Enter a valid name" };
  }

  //Passed all checks
  return { valid: true, message: "Valid name" };
}

export function emailValidation(email) {
  const ERROR = {
    email: "Invalid email",
  };

  //Check if email is a string
  if (typeof email !== "string") {
    return { valid: false, message: ERROR.email };
  }

  email = email.trim();

  // RFC 2822 standard max length
  if (email.length > 254) {
    return { valid: false, message: "Email is too long" };
  }

  // A common and fairly comprehensive regex for email validation
  const emailPattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  if (!emailPattern.test(email)) {
    return { valid: false, message: "Please enter a valid email address" };
  }

  // Spam checks
  const atIndex = email.lastIndexOf('@');
  const localPart = email.substring(0, atIndex);
  const domain = email.substring(atIndex + 1);

  // Check for at least one vowel in the local part
  if (!/[aeiou]/i.test(localPart)) {
    return { valid: false, message: "Please enter a valid email address" };
  }

  // Check for not too many consecutive consonants in local part
  if (/[bcdfghjklmnpqrstvwxyz]{5,}/i.test(localPart)) {
    return { valid: false, message: "Please enter a valid email address" };
  }

  const domainName = domain.split('.')[0];
  if (domainName) {
    // Check for at least one vowel in the domain name
    if (!/[aeiou]/i.test(domainName)) {
      return { valid: false, message: "Please enter a valid email address" };
    }
    // Check for not too many consecutive consonants in domain name
    if (/[bcdfghjklmnpqrstvwxyz]{5,}/i.test(domainName)) {
      return { valid: false, message: "Please enter a valid email address" };
    }
  }

  //Passed all checks
  return { valid: true, message: "Valid email" };
}